import React, { useState , useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import  PagosTable from './components';
import { Typography } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const  PagosList = () => {
  const classes = useStyles();

  const[users] = "";




  return (
    <div className={classes.root}>
      <div className={classes.content}>
      <br></br>
        <Typography variant="h2">
         Pagos Congreso
        </Typography>
        <br></br>
        <PagosTable users={users} />
      </div>
    </div>
  );
};

export default PagosList;